import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { MultiEmailInput } from '@/modules/common/components/molecules/inputs/multi-email-input';

import { UpdateInvoiceFormValues } from '../../validations';

interface InvoiceReceiversCardProps {
  form: UseFormReturn<UpdateInvoiceFormValues>;
  isReadOnly: boolean;
}

const RECEIVER_FIELDS = [
  { name: 'receiverEmails.to', labelKey: 'details.fields.toEmails' },
  { name: 'receiverEmails.cc', labelKey: 'details.fields.ccEmails' },
  { name: 'receiverEmails.bcc', labelKey: 'details.fields.bccEmails' },
] as const;

export function InvoiceReceiversCard({ form, isReadOnly }: InvoiceReceiversCardProps) {
  const { t } = useTranslation(['authenticated.invoices']);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('details.receivers')}</CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        {RECEIVER_FIELDS.map(receiverField => (
          <FormField
            key={receiverField.name}
            control={form.control}
            name={receiverField.name}
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t(receiverField.labelKey)}</FormLabel>
                <FormControl>
                  <MultiEmailInput
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    disabled={isReadOnly}
                    placeholder={t('details.edit.placeholders.emails')}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        ))}
      </CardContent>
    </Card>
  );
}
